import authenticateUser from './authenticate-user'
import registerUser from './register-user'
import retrieveUser from './retrieve-user'
import listColumns from './list-columns'
import createTask from './create-task'
import createColumns from './create-columns'
import changePosition from './change-position'
import deleteTask from './delete-task'
import editTask from './edit-task'

export default {
  authenticateUser,
  registerUser,
  retrieveUser,
  listColumns,
  createTask,
  createColumns,
  changePosition,
  deleteTask,
  editTask
}
